import { FC } from 'react';

type Props = {
	className?: string;
};

const AgreementIconSolid: FC<Props> = ({ className }) => {
	return (
		<svg
			width='20'
			height='20'
			viewBox='0 0 20 20'
			xmlns='http://www.w3.org/2000/svg'
			fill='#2B2B2B'
			stroke='none'
			className={className}>
			<path
				d='M9.53481 4.88618L8.44162 4.40992L8.43278 4.40625C7.44087 3.99428 6.37706 4.33848 5.69677 5.18611L5.32296 5.65186C5.28765 5.69586 5.23428 5.72145 5.17787 5.72145H2.55813C2.24989 5.72145 2 5.97134 2 6.27958V12.9771C2 13.2853 2.24989 13.5352 2.55813 13.5352H5.3206C5.35559 13.5352 5.38988 13.5451 5.41952 13.5637L6.70851 14.3728L6.73431 14.3895C7.4126 14.8266 7.96228 15.1809 8.43849 15.4148C8.93434 15.6583 9.40361 15.7992 9.92148 15.7618C10.6346 15.7104 11.2287 15.3424 11.7027 14.9526C12.0269 14.6859 12.345 14.363 12.6167 14.0872C12.7304 13.9718 12.8359 13.8647 12.9303 13.7734L13.4774 13.2444L10.7381 9.13726C10.6769 9.04542 10.5496 9.02682 10.4646 9.09737L10.3101 9.22566C10.09 9.44676 9.72026 9.72195 9.27628 9.83864C8.77441 9.97043 8.17815 9.89147 7.7011 9.35247C7.26509 8.85983 7.16459 8.31079 7.23056 7.83747C7.29335 7.38703 7.5037 7.01163 7.69096 6.78779C7.69888 6.77832 7.70711 6.76912 7.71564 6.76019L9.05303 5.36143L9.06338 5.35093C9.20827 5.20714 9.36856 5.04922 9.53481 4.88618Z'
				fill='inherit'
			/>
			<path
				d='M14.9596 13.4557C15.1422 13.5084 15.3331 13.5359 15.5272 13.5359H17.4415C17.5898 13.5359 17.7319 13.477 17.8365 13.3721C17.9412 13.2672 18 13.1249 17.9997 12.9768L17.9866 6.2792C17.986 5.97138 17.7362 5.72217 17.4284 5.72217H15.3698C14.946 5.46635 14.3325 5.0998 13.6913 4.79832C13.1151 4.52739 12.4306 4.26571 11.8046 4.23584C11.6658 4.37016 11.4815 4.5486 11.2749 4.74915C10.8266 5.18432 10.2749 5.72205 9.85477 6.13889L8.53737 7.5167C8.46233 7.6113 8.36423 7.79044 8.3361 7.99228C8.30993 8.18012 8.34107 8.39204 8.53699 8.6134C8.6283 8.71655 8.7057 8.75316 8.7624 8.76804C8.82357 8.78404 8.89881 8.78434 8.99265 8.75971C9.19559 8.70635 9.40566 8.55648 9.52979 8.42772C9.54408 8.41289 9.55919 8.39887 9.57504 8.3857L9.75148 8.23923C10.3463 7.7454 11.2378 7.87545 11.6668 8.5186L14.9596 13.4557Z'
				fill='inherit'
			/>
		</svg>
	);
};

export default AgreementIconSolid;
